import * as React from "react";
import Skeleton from "react-loading-skeleton";
const Common_Shimmer = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `common-shimmer ${props.className ? props.className : ""}` },
            React.createElement(Skeleton, { className: "SkeletonTile h-40", count: props.number ? props.number : 4 }))));
};
export default Common_Shimmer;
